import React from "react";
import "./NoVenue.scss";
import { useNavigate } from "react-router-dom";

const NoVenue = () => {
  const navigate = useNavigate();
  return (
    <div className="no-games-container">
      <p className="subtextMain-Novenue">
        We’re setting the nets, chalking the lines, <br /> and getting your city
        game-ready.
      </p>
      <br />
      <p className="subtext-Novenue">Launching in a few weeks.</p>
    </div>
  );
};

export default NoVenue;
